/**
 * Vehicle classes that match the existing kfzForm content list (data.ts).
 * The string `value` MUST be identical to what the legacy form expects so
 * the existing `saveKfzRiskObject` translation continues to work.
 *
 * `iconKey` selects an inline SVG silhouette in VehicleClassPicker.tsx.
 */
export type VehicleClassDef = {
  value: string;
  short: string;
  description: string;
  iconKey:
    | "pkw"
    | "lieferwagen"
    | "lkw"
    | "zugmaschine"
    | "bus"
    | "anhaenger"
    | "arbeitsmaschine"
    | "stapler"
    | "krad"
    | "sonderfahrzeug";
};

export const VEHICLE_CLASSES: VehicleClassDef[] = [
  {
    value: "Klasse 1 PKW",
    short: "PKW",
    description: "Personenkraftwagen",
    iconKey: "pkw",
  },
  {
    value: "Klasse 2 Lieferwagen Güterbeförderung bis 3.500kg",
    short: "Lieferwagen",
    description: "Güterbeförderung bis 3,5 t",
    iconKey: "lieferwagen",
  },
  {
    value: "Klasse 3 LKW Güterbeförderung über 3.500kg",
    short: "LKW",
    description: "Güterbeförderung über 3,5 t",
    iconKey: "lkw",
  },
  {
    value: "Klasse 4 Zugmaschine (Sattelzug, Land-/Forstwirtschaft, Unimog, etc.)",
    short: "Zugmaschine",
    description: "Sattelzug, Unimog, …",
    iconKey: "zugmaschine",
  },
  {
    value: "Klasse 5 Busse",
    short: "Bus",
    description: "Personenbeförderung",
    iconKey: "bus",
  },
  {
    value: "Klasse 6 Anhänger/Auflieger",
    short: "Anhänger",
    description: "Anhänger / Auflieger",
    iconKey: "anhaenger",
  },
  {
    value: "Klasse 7 Arbeitsmaschinen",
    short: "Arbeitsmaschine",
    description: "Selbstfahrend",
    iconKey: "arbeitsmaschine",
  },
  {
    value: "Klasse 8 Gabelstapler",
    short: "Gabelstapler",
    description: "Innerbetrieblich",
    iconKey: "stapler",
  },
  {
    value: "Klasse 9 Krad",
    short: "Krad",
    description: "Motorrad / Roller",
    iconKey: "krad",
  },
  {
    value: "Klasse 10 Sonderfahrzeuge",
    short: "Sonderfahrzeug",
    description: "Sonstige Fahrzeuge",
    iconKey: "sonderfahrzeug",
  },
];
